import styled from 'styled-components';
import { Sizes } from '../../utils/sizes';
import { Colors } from '../../utils/colors';

export const PageContainer = styled.section`
  width: 100%;
  background: #0a0a0a;
  padding: 60px 20px 80px;
  min-height: 100vh;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.2), transparent);
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 44px;

  h1 {
    color: #fff;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    margin: 0 0 10px;
    letter-spacing: -0.5px;

    span { color: ${Colors.yellow}; }
  }

  p {
    color: rgba(255,255,255,0.5);
    font-size: 1rem;
    margin: 0;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 32px;
`;

export const FilterButton = styled.button`
  padding: 8px 18px;
  background: ${p => p.active ? Colors.yellow : 'rgba(255,255,255,0.05)'};
  color: ${p => p.active ? '#0a0a0a' : 'rgba(255,255,255,0.6)'};
  border: 1px solid ${p => p.active ? Colors.yellow : 'rgba(255,255,255,0.12)'};
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  transition: all 0.15s;

  &:hover {
    background: ${p => p.active ? Colors.yellow : 'rgba(255,215,0,0.1)'};
    border-color: ${Colors.yellow};
    color: ${p => p.active ? '#0a0a0a' : Colors.yellow};
  }
`;

export const StatsBar = styled.div`
  margin-bottom: 20px;

  .results-count {
    color: rgba(255,255,255,0.35);
    font-size: 12px;
    letter-spacing: 0.5px;
  }
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
  }

  @media (max-width: ${Sizes.mediaQueryBreak3}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 80px 20px;
  border: 1px dashed rgba(255,215,0,0.2);
  border-radius: 12px;
  color: rgba(255,255,255,0.4);

  h3 {
    font-size: 1.3rem;
    color: ${Colors.yellow};
    margin-bottom: 8px;
  }

  p { font-size: 0.9rem; }
`;
